import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Container,
  Grid,
  Typography,
  Box,
  IconButton,
  CircularProgress,
} from "@mui/material";

import Header from "../components/Header/Header";
import Footer from "../components/shared/Footer";
import { appTitle } from "../common/Helper";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@mui/icons-material";
import { ServerProductQuoteCard } from "../components/ServerProductQuotes/QuoteCard";
import { QuoteViewModal } from "../components/ServerProductQuotes/QuoteViewModel";
import {
  useGetServerQuotesQuery,
  useUpdateQuoteMutation,
  useDeleteQuoteMutation,
} from "../services/ServerProductService";

export const ServerProductQuotesPage: React.FC = () => {
  const [page, setPage] = useState(1);
  const [selectedQuote, setSelectedQuote] = useState<any>(null);

  // ✅ RTK QUERY
  const { data, isLoading, isFetching } = useGetServerQuotesQuery({
    limit: 10,
    page,
  });

  const [updateQuote] = useUpdateQuoteMutation();
  const [deleteQuote] = useDeleteQuoteMutation();

  // ✅ API response safe access
  const quotes = data?.response || [];

  const handleChangePage = (next = false) => {
    setPage((prev) => (next ? prev + 1 : prev > 1 ? prev - 1 : 1));
  };

  return (
    <>
      <Helmet>
        <title>{appTitle + " - Server Product Quotes"}</title>
      </Helmet>

      <Header />

      <Container maxWidth="lg">
        <Grid container sx={{ mt: 4, mb: 4 }}>
          {/* HEADER */}
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Server Product Quotes
            </Typography>
          </Grid>

          {/* LOADING */}
          {isLoading && (
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" mt={5}>
                <CircularProgress />
              </Box>
            </Grid>
          )}

          {/* LIST */}
          {!isLoading &&
            quotes.map((quote: any) => (
              <ServerProductQuoteCard
                key={quote.id}
                quote={quote}
                clickCard={(q: any) => setSelectedQuote(q)}
              />
            ))}

          {/* EMPTY STATE */}
          {!isLoading && quotes.length === 0 && (
            <Grid item xs={12}>
              <Typography align="center" sx={{ mt: 5 }}>
                No quotes found
              </Typography>
            </Grid>
          )}

          {/* PAGINATION */}
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={3}
            >
              <IconButton onClick={() => handleChangePage(false)}>
                <ArrowLeftOutlined />
              </IconButton>

              <Typography>Page {page}</Typography>

              <IconButton onClick={() => handleChangePage(true)}>
                <ArrowRightOutlined />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* MODAL */}
      <QuoteViewModal
        open={!!selectedQuote}
        quote={selectedQuote}
        onClose={() => setSelectedQuote(null)}
        updateQuote={updateQuote}
        deleteQuote={deleteQuote}
      />

      <Footer />
    </>
  );
};
